const ServerUrl = process.env.NEXT_PUBLIC_SERVER_URL;

export const leadSubmit = async (jsonData, payload) => {
  try {
    const res = await fetch(`${ServerUrl}/lead-details`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${process.env.NEXT_PUBLIC_STRAPI_JWT_TOKEN}`
      },
      body: JSON.stringify({ data: jsonData })
    });
    const res1 = await fetch(
        "https://partner.medhaviskillsuniversity.edu.in/partnar/all-student-query-of-msu/",
        { method: "POST", body:payload}
      );

    const data = await res.json();
    const data1 = await res1.json()
    console.log("Response from Strapi:", data);
    console.log("Response from sheet :", data1);
    return data;
  } catch (err) {
    console.error("Error pushing data to Strapi:", err);
    return null;
  }
};
// Example usage
// const leadData = {
//   Name: "John Doe",
//   email: "john@example.com",
//   phone: "9876543210",
//   BrochureDownload: true,
//   blogs: [1, 2],
//   categories: [3],
//   subcategories: [5, 6],
//   courses: [2]
// };

// LeadSubmit("lead-detail", leadData);
